export default __webpack_public_path__ + "img/MYMY-logo.37e3ba3f228c72b38327ab1d71e0f8a0.png";